/**
 * Trunnion AI - Admin Layout
 * Admin section with sub-navigation.
 */

import { Outlet, NavLink } from 'react-router-dom';
import { Shield, Wrench, Cpu, Users, FlaskConical } from 'lucide-react';
import { ROUTES } from '@/config/routes';

const adminNavItems = [
  { icon: Shield, label: 'Policies', path: ROUTES.ADMIN_POLICIES },
  { icon: Wrench, label: 'Tool Registry', path: ROUTES.ADMIN_TOOLS },
  { icon: Cpu, label: 'LLM Providers', path: ROUTES.ADMIN_LLM },
  { icon: Users, label: 'Users', path: ROUTES.ADMIN_USERS },
  { icon: FlaskConical, label: 'Simulator', path: ROUTES.ADMIN_SIMULATOR },
];

export function AdminLayout() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-white">Administration</h1>
        <p className="mt-1 text-sm text-trunnion-slate-400">
          Manage platform policies, tools, providers, and users.
        </p>
      </div>

      <div className="flex gap-2 border-b border-trunnion-slate-700 pb-px">
        {adminNavItems.map(({ icon: Icon, label, path }) => (
          <NavLink
            key={path}
            to={path}
            className={({ isActive }) =>
              `flex items-center gap-2 rounded-t-lg px-4 py-2.5 text-sm font-medium transition-colors border-b-2 ${
                isActive
                  ? 'border-trunnion-gold-500 text-trunnion-gold-500 bg-trunnion-gold-500/5'
                  : 'border-transparent text-trunnion-slate-400 hover:text-white'
              }`
            }
          >
            <Icon className="h-4 w-4" />
            {label}
          </NavLink>
        ))}
      </div>

      <Outlet />
    </div>
  );
}
